import ro from './ro.js';
import en from './en.js';

export default {ro, en};
